export default function base64ToUint8Array(base64: string): Uint8Array {
  const cleaned = base64.replace(/^data:[^,]*,/, '');
  const binaryString = atob(cleaned);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}
